import * as React from 'react';

import type {QuoteDisplayStatus} from 'nutshell-graphql-types';

import type {QuoteTimes} from '../../../../../../ui/lead/sales-documents/shared';

import {StatusBadge} from '../../status-badge/status-badge';

import {
    getBadgeLevel,
    getIcon,
    getSalesDocumentStatusText,
    getSalesDocumentStatusTime,
} from './helpers';
import type {SalesDocumentType} from './types';

type Props = {
    status: QuoteDisplayStatus;
    salesDocumentTimes?: QuoteTimes;
    type: SalesDocumentType;
    invoiceOverdueDuration?: string | null | undefined;
    isSmall?: boolean;
};

export function SalesDocumentStatusBadge(props: Props) {
    const {status, type, salesDocumentTimes, invoiceOverdueDuration} = props;

    return (
        <StatusBadge
            level={getBadgeLevel(status, invoiceOverdueDuration)}
            text={getSalesDocumentStatusText(status, type, invoiceOverdueDuration)}
            customIcon={getIcon(status, type, invoiceOverdueDuration)}
            size={props.isSmall ? 'small' : 'normal'}
            smallIcon={props.isSmall}
            detail={
                salesDocumentTimes
                    ? getSalesDocumentStatusTime(
                          status,
                          type,
                          salesDocumentTimes,
                          invoiceOverdueDuration
                      )
                    : ''
            }
        />
    );
}
